import React, { useState, useEffect, useContext } from 'react'
import { BroadcastCon, ScheduleTableCon, WeekBoxCon } from './weekStyles'
import { GameAction } from '../../../../Components/Buttons/GameAction'
import {
  checkIsMarketIncomplete,
  getBroadcastImg,
  getShortMarket,
  renderDateAndTime,
} from '../../../../Utils/Events/eventHelpers'
import { getUserTimezone } from '../../../../Utils/formatting'
import { TeamsCol } from './TeamsCol'
import { BROADCASTER_LINKS } from '../../../../Config/config'
import type { EventGQL } from '../../../../Api'
import { ChampSeriesTable } from './ChampSeriesTable'
import { NoDateCallout } from './NoDateCallout'
import { Img } from '../../../../Components/Image/Img'
import { Desc } from '../../../../Components/Typography/Text.styles'
import { HomecomingPassCallout } from '../callouts/HomecomingPassCallout'
import { SeasonContext } from '../../../../Context'
import { SpecialEventsCallout } from '../callouts/SpecialEvent'
import { Lk } from '../../../../Components/Links/Lk'
import { ListAnimation } from '../../../../Components/Animations/ListAnimations'
type WeekBoxParams = {
  week: string
  events: EventGQL[]
  showInET: boolean
}

export const WeekBox: React.FC<React.PropsWithChildren<WeekBoxParams>> = ({
  week,
  events,
  showInET = false,
}) => {
  let { incompleteMarkets } = useContext(SeasonContext)!
  const [isIncomplete, setIsIncomplete] = useState<boolean>(true)

  useEffect(() => {
    if (events.length > 0) {
      //Checking if market is complete or not
      let isIncomp = checkIsMarketIncomplete(week, incompleteMarkets)
      setIsIncomplete(isIncomp)
    }
  }, [events])

  const findPresaleUrl = () => {
    let ev = events.find((e) => e.week === week)
    if (ev) {
      return ev
    } else {
      return events[0]
    }
  }

  if (events.length === 0) {
    return <div />
  }

  return (
    <>
      <WeekBoxCon>
        {events.length > 0 && events[0].seasonSegment === 'champseries' && (
          <ChampSeriesTable week={week} events={events} showInET={showInET} />
        )}
        {events.length > 0 && isIncomplete && (
          <>
            <NoDateCallout event={findPresaleUrl()} page="schedule" />
          </>
        )}
        {events.length > 0 &&
          events[0].seasonSegment !== 'champseries' &&
          !isIncomplete && (
            <>
              <ScheduleTableCon>
                <tbody>
                  {events.map((event, index) => (
                    <ListAnimation key={event.slugname} index={index} component="tr">
                      <td>{renderDateAndTime(event.startTime, showInET)}</td>
                      <td>
                        <TeamsCol description={event.description} event={event} />
                      </td>
                      <td>
                        <BroadcastCon>
                          <Lk
                            link={
                              event.urlStreaming || BROADCASTER_LINKS.generalESPNPlus
                            }
                            alt="Broadcaster icons"
                          >
                            {getBroadcastImg(event.broadcaster).map((img, idx) => (
                              <Img key={idx} className="broadcaster" src={img} alt="" />
                            ))}
                          </Lk>
                        </BroadcastCon>
                      </td>
                      <td>
                        {event.awayTeam && (
                          <GameAction event={event} section={'schedule'} />
                        )}
                      </td>
                    </ListAnimation>
                  ))}
                </tbody>
              </ScheduleTableCon>
              <SpecialEventsCallout week={parseInt(week)} showInET={showInET} />
            </>
          )}
        <HomecomingPassCallout market={getShortMarket(events[0])} />
        <Desc sideMargins={1}>{`*All times ${getUserTimezone()}`}</Desc>
      </WeekBoxCon>
    </>
  )
}
